<template>
  <Modal :model-value="modelValue" @update:model-value="updateModelValue" :max-width="500">
    <template v-slot:title>
      {{ t('contact-manager') }}
    </template>
    <template v-slot:content>
      <p>{{ t('crew-support-message') }}</p>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn color="primary" @click="closeModal">
        {{ t('ok') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import Modal from './Modal.vue';

const { t } = useI18n();

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

function updateModelValue(value) {
  emit('update:modelValue', value);
}

function closeModal() {
  emit('update:modelValue', false);
}
</script>

<i18n>
{
  "en": {
    "contact-manager": "Contact Your Manager",
    "crew-support-message": "Please contact your manager for assistance. Your manager can submit a support ticket on your behalf if needed.",
    "ok": "OK"
  },
  "es": {
    "contact-manager": "Contacta a tu Gerente",
    "crew-support-message": "Por favor contacta a tu gerente para asistencia. Tu gerente puede enviar un ticket de soporte en tu nombre si es necesario.",
    "ok": "OK"
  }
}
</i18n>